export enum enumTransacao {
    MonitorCliente = 1,
        Upload = 2,
        Cliente = 3,
        Operador = 4,
        Usuario=5,
        Monitor = 6,
        Parametrizacao = 7,
        MonitorOperacao = 8,
        HorarioOperacao = 10,
        Operacao=11,
        PerfilConta=12,
        Extrato=13,
        Investimento=14,
        Transferencia=15,
        Pagamento=19,
        Tributos=21,
        Pix=22,
        Chaves=23,
        PagamentoPix=24,
        ReceberPix=25,
        ExtratoPix=26,
        QrCodesPix=27,
        Administracao=28,
        UsuarioConta=29,
        Saldo,
        DevolverPix,
        LimiteTipoCliente=32,
        Favorecido=33,
        Alerta=34,
        LogAcao=35,
        MonitorArquivo,
        MonitorOperacoes,
        Perfil,
        LimitePix,
        Relatorios,
        FavorecidoPix,
        RegistrarReclamacao=42,
    ControleReclamacao = 43,
    ConsentimentoPagamentoOpenBanking = 44,
        AprovacaoLimite=45,
        Cambio=46,
        OpenBanking=47,
        MeusPagamentos=48,
        Infracoes=49,
        DevolucaoEspecial=50,
        EmissaoTitulo=51,
        InformeRendimento=52,
        MonitorAprovacaoOperacao=53,
        MonitorAprovacaoEdicaoUsuario=54
}
